import {
  faAlarmClock,
  faAngleDown,
  faAnglesDown,
  faAnglesUp,
  faAnglesUpDown,
  faArchive,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowTurnDownLeft,
  faArrowTurnDownRight,
  faArrowTurnRight,
  faArrowsAlt,
  faArrowUp,
  faArrowUpFromLine,
  faArrowUpRightFromSquare,
  faAsterisk,
  faAt,
  faBan,
  faBold,
  faBolt,
  faBook,
  faBorderAll,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDashed,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faComments,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faClone,
  faCommentsAlt,
  faCopy,
  faCreditCard,
  faCrown,
  faDatabase,
  faDotCircle,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faEquals,
  faExchange,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFaceAwesome,
  faFileAlt,
  faFileCheck,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFiles,
  faFileSignature,
  faFileUpload,
  faFileWord,
  faFileXmark,
  faFolder,
  faFolderOpen,
  faFolderUpload,
  faFontCase,
  faGavel,
  faGear,
  faHeading,
  faHighlighter,
  faHighlighterLine,
  faHourglassStart,
  faHouse,
  faICursor,
  faIdBadge,
  faIdCard,
  faIndent,
  faItalic,
  faKey,
  faLevelUp,
  faLink,
  faList,
  faListAlt,
  faListOl,
  faLockAlt,
  faMagnifyingGlass,
  faMemo,
  faMinus,
  faOutdent,
  faPaperclip,
  faPen,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRectangleHistory,
  faRedo,
  faRemoveFormat,
  faSave,
  faSdCard,
  faSearch,
  faShare,
  faShieldCheck,
  faSidebarFlip,
  faSignature,
  faSlidersH,
  faSort,
  faSpinnerThird,
  faSquare,
  faStrikethrough,
  faTableLayout,
  faTasks,
  faTextSize,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTrashAlt,
  faTrashCan,
  faUnderline,
  faUser,
  faUserFriends,
  faUserLock,
  faUserPen,
  faUserShield,
  faUsers,
  faVault,
  faXmark,
} from '@awesome.me/kit-da13514c94/icons/classic/regular'

export const regularLibrary = [
  faAlarmClock,
  faAngleDown,
  faAnglesDown,
  faAnglesUp,
  faAnglesUpDown,
  faArchive,
  faArrowDownToLine,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowTurnDownLeft,
  faArrowTurnDownRight,
  faArrowTurnRight,
  faArrowsAlt,
  faArrowUp,
  faArrowUpFromLine,
  faArrowUpRightFromSquare,
  faAsterisk,
  faAt,
  faBan,
  faBold,
  faBolt,
  faBook,
  faBorderAll,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCheck,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleDashed,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faComments,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faClone,
  faCommentsAlt,
  faCopy,
  faCreditCard,
  faCrown,
  faDatabase,
  faDotCircle,
  faEdit,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faEquals,
  faExchange,
  faExclamationTriangle,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFaceAwesome,
  faFileAlt,
  faFileCheck,
  faFileExcel,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFiles,
  faFileSignature,
  faFileUpload,
  faFileWord,
  faFileXmark,
  faFolder,
  faFolderOpen,
  faFolderUpload,
  faFontCase,
  faGavel,
  faGear,
  faHeading,
  faHighlighter,
  faHighlighterLine,
  faHourglassStart,
  faHouse,
  faICursor,
  faIdBadge,
  faIdCard,
  faIndent,
  faItalic,
  faKey,
  faLevelUp,
  faLink,
  faList,
  faListAlt,
  faListOl,
  faLockAlt,
  faMagnifyingGlass,
  faMemo,
  faMinus,
  faOutdent,
  faPaperclip,
  faPen,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRectangleHistory,
  faRedo,
  faRemoveFormat,
  faSave,
  faSdCard,
  faSearch,
  faShare,
  faShieldCheck,
  faSidebarFlip,
  faSignature,
  faSlidersH,
  faSort,
  faSpinnerThird,
  faSquare,
  faStrikethrough,
  faTableLayout,
  faTasks,
  faTextSize,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTrashAlt,
  faTrashCan,
  faUnderline,
  faUser,
  faUserFriends,
  faUserLock,
  faUserPen,
  faUserShield,
  faUsers,
  faVault,
  faXmark,
]
